jQuery(function($){

	// --------------------------------------------------------------------------
	//   Menu
	// --------------------------------------------------------------------------


	var menuToggle = '<div id="menu-toggle">☰</div>';

	if (!$('#menu-toggle').length) $('#header-wrapper').prepend(menuToggle);

	$('#menu-toggle').click(function() {

		$('html').toggleClass('js-nav');
		$('#main-nav').focus();

	});

	$('#main-nav li').hoverIntent( {


	over: function() {

		$(this).children('.sub-menu').show(0, function() {
			$(this).css("overflow","visible");
		});
		if ($(this).children('.sub-menu').length) {
			$(this).addClass('active');
		}
	}, timeout: 200,


	out: function() {

		$(this).children('.sub-menu').delay(200).hide(0, function() {
			$(this).parent().removeClass('active');
		}).css("overflow","visible");


	} });


	// --------------------------------------------------------------------------
	//   Hero slider
	// --------------------------------------------------------------------------

	if ($('#hero-products').length) {

		var $frame = $('#hero-products');
		var $wrap  = $frame.parent();

		var slyoptions = {
			horizontal: 1,
			itemNav: 'centered',
			itemSelector: '.product',
			activateOn: 'click',
			smart: 1,
			mouseDragging: 1,
			touchDragging: 1,
			releaseSwing: 1,
			swingSpeed: 0.2,
			elasticBounds: 1,
			easing: 'easeOutExpo',
			scrollBy: 0,

			moveBy:        300,
			speed:         800,

			prevPage: $('.controls .prev'),
			nextPage: $('.controls .next'),

			scrollBar: $('#scrollbar'),
			dragHandle: 1,
			dynamicHandle: 1,
			clickBar: 1
		}

		var sly = new Sly( $('#hero-products'), slyoptions ).init();



		sly.activate(sly.rel['centerItem'], true)

		$(window).resize(function(e) {
			$('#hero-products').sly('reload');
		});

	}


	// --------------------------------------------------------------------------
	//   Club Page Radio Buttons
	// --------------------------------------------------------------------------

	$('.product-select:checked').next('label').addClass('active');

	$('.product-select').change(function(){
		var $this = $(this);

		if ($this.is(':checked')) {
			$this.siblings('label').removeClass('active');
			$this.next('label').addClass('active');
		} else {
			$this.next('label').removeClass('active');
		}
	});

	// --------------------------------------------------------------------------
	//   Product Title Truncate
	// --------------------------------------------------------------------------

	$('article.product h3').each(function() {
		$(this).text(truncate($(this).text()));
	});

	// --------------------------------------------------------------------------
	//   AJAX Shopping
	// --------------------------------------------------------------------------

	Shopify.onCartUpdate = function(cart) {

		console.log('There are now ' + cart.item_count + ' items in the cart.');

		$('.cart-items').text(cart.item_count + " items");

	};

	Shopify.onItemAdded = function(line_item) {

		console.log(line_item.title + ' was added to the shopping cart.');

		Shopify.getCart();

		window.location.href = "/cart/";

	}

	$('.add-to-cart').click(function() {

		variant = $(this).data('variant');

		Shopify.addItem(variant);

		return false;

	});


	// --------------------------------------------------------------------------
	//   Product Single
	// --------------------------------------------------------------------------

		$('.bottle-price').each(function() {
			$(this).html($(this).html().replace(/\$?(?=\(.*\)|[^()]*$)\(?\d{1,3}(,?\d{3})?(\.\d\d?)?\)?/, '<span class="price">$&</span><br>'));
		})

	// --------------------------------------------------------------------------
	//   Stop auto scrolling on user override
	// --------------------------------------------------------------------------

	if(window.addEventListener) document.addEventListener('DOMMouseScroll', stopScroll, false);
		document.onmousewheel = stopScroll;

	function stopScroll() {
		$('html, body').stop(true, false);	// Stops and dequeue's animations
	}


	// --------------------------------------------------------------------------
	//   ScrollTo
	// --------------------------------------------------------------------------

	function scrollTo(anchor) {

		$('html, body').stop().animate({

			scrollTop: $(anchor).offset().top

		}, 1200,'easeInOutExpo');

	}


	// --------------------------------------------------------------------------
	//   Hash Scroll
	// --------------------------------------------------------------------------

	if (window.location.hash && $(window.location.hash).length) {
		setTimeout(function() {
		  if (location.hash) {
		    window.scrollTo(0, 0);
		  }
		}, 1);

		setTimeout(
			function(){
				scrollTo(window.location.hash);
			}, 400);
	}

	// --------------------------------------------------------------------------
	//   Truncate
	// --------------------------------------------------------------------------

	function truncate(string){
	   if (string.length > 60)
	      return string.substring(0,60)+'...';
	   else
	      return string;
	};

});
